import { Notifications } from "@mantine/notifications";
import 'dayjs/locale/pt-br';
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import { AppProvider } from "./contexts/app.context";
import { AuthProvider } from "./contexts/auth.context";
import { RequireAuth } from "./utility/requireAuth";
import routes from "./utility/routes";

function App() {
  return <>
    <BrowserRouter>
      <Notifications position="top-right" />

      <AuthProvider>
      <AppProvider>
        <Routes>
          {routes.filter(r => !r.private).map((r, i) => <Route key={`${i}`} path={r.url} element={r.component} />)}
          <Route element={<RequireAuth />}>
            {routes.filter(r => r.private).map((r, i) => <Route key={`${i}`} path={r.url} element={r.component} />)}
          </Route>
        </Routes>
      </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  </>
}

export default App;
